import { gql } from '@apollo/client';
import CollectionFields from 'actions/user/CollectionFields.graphql';

export default gql`
  query GetCollections(
    $tags: [String]
    $excludeTags: [String]
    $excludeOwn: Boolean
    $orderBy: CollectionsSortOrder
    $orderByDirection: SortOrderDirection
    $limit: Int
    $offset: Int
  ) {
    Collections(
      tags: $tags
      excludeTags: $excludeTags
      excludeOwn: $excludeOwn
      orderBy: $orderBy
      orderByDirection: $orderByDirection
      limit: $limit
      offset: $offset
    ) {
      ...CollectionFields
    }
  }
  ${CollectionFields}
`;
